import { Box } from "@mui/material";

interface TagListProps {
  tags: string[];
}

export const TagList = ({ tags }: TagListProps) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1.5 }}>
      {tags.map((tag, index) => (
        <Box 
          key={index}
          sx={{
            backgroundColor: "grey.100",
            borderRadius: "12px",
            px: 1,
            py: 0.25,
            fontSize: "0.7rem",
          }}
        >
          #{tag}
        </Box>
      ))}
    </Box>
  );
};
